module.exports = __webpack_public_path__ + "img/fangzuobi-tips@2x.ad80ffb6.png";